<template>
  <div class="item" v-if="item.fields">
    <div class="item-row" v-for="(row, i) in metadata.rows" :key="i">
      <form-row
        v-for="{ name } in row.fields"
        :key="name"
        :rules="rules[`${item.id}__${name}`]"
        :prop="`${item.id}__${name}`"
        :field="{
          ...schema[name],
          ...dynamicParams(name, schema[name])
        }"
        :options="defaultOptions(name, schema[name])"
        :model="getField(name).value"
        :form="parentForm"
        @set-value="
          (n, val) =>
            handleChange({
              [`${item.id}__${name}`]: val
            })
        "
        @change-option="changeOption"
        @change-rellink-option="changeRellinkOption"
        class="address-item"
      ></form-row>
    </div>
  </div>
</template>
<script>
import FormRow from 'Elements/Form/FormRow';
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    schema: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number
    },
    disabled: Boolean,
    parentForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      metadata: {
        rows: [
          { fields: [{ name: 'place_addr' }] },
          { fields: [{ name: 'city' }, { name: 'subway_station' }] },
          { fields: [{ name: 'comment' }] }
        ]
      },
      rules: {},
      subwayOptions: {},
      defaultKey: 0
    };
  },
  created() {
    if (!this.item.fields) return;

    this.item.fields.forEach(item => {
      if (!this.schema[item.name]) return;

      if (this.schema[item.name].required) {
        this.$set(this.rules, `${this.item.id}__${item.name}`, {
          required: true,
          message: 'Необходимо заполнить поле',
          trigger: ['blur', 'focus', 'change']
        });
      }
    });
  },
  methods: {
    dynamicParams(name, field) {
      const params = {
        name: `${this.item.id}__${name}`
      };
      if (this.disabled) {
        params.visibility = 'disabled';
      }
      if (field.type == 'relate' && field.id_name) {
        params['id_name'] = {
          ...field.id_name,
          value: this.getField(field.id_name?.name).value
        };
      }
      if (field.type == 'relate') {
        params['visual_value'] = {
          id: this.getField(field.id_name?.name).value,
          name: this.getField(name).value
        };
        params.value = this.getField(name).value;
      }
      if (field.type == 'rellink' && field.multiple) {
        const defaultOptions = {};
        const ids = this.getField(name).value;
        const names = this.getField(field.rellink_child).value;
        ids.forEach((id, index) => (defaultOptions[id] = names[index]));

        params['visual_value'] = defaultOptions;
        params.value = this.getField(name).value;
      }

      return params;
    },
    defaultOptions(name, field) {
      if (field.type == 'relate') {
        return [
          {
            id: this.getField(field?.id_name?.name).value,
            name: this.getField(name).value
          }
        ];
      } else if (field.type == 'rellink' && field.multiple) {
        const ids = this.getField(name).value || [];
        const names = this.getField(field.rellink_child).value || [];
        return ids.map((id, index) => ({ id, name: names[index] }));
      }
      return [];
    },
    handleChange(fields = {}) {
      this.$emit('set-value', this.item, this.index, fields);
    },
    changeOption(name, idField, opt) {
      if (idField && opt) {
        this.$emit('set-value', this.item, this.index, {
          [`${this.item.id}__${idField.name}`]: opt.id
        });

        this.resetSubwayField(name, opt.id);
      }
    },
    resetSubwayField(name, value) {
      const cleanedField =
        this.schema[name.split('__')[1]] &&
        this.schema[name.split('__')[1]]?.clean_field;

      if (cleanedField && value === '') {
        this.$emit('set-value', this.item, this.index, {
          [`${this.item.id}__${cleanedField}`]: []
        });
        if (this.schema[cleanedField]?.rellink_child) {
          this.$emit('set-value', this.item, this.index, {
            [`${this.item.id}__${this.schema[cleanedField].rellink_child}`]: []
          });
        }
      }
    },
    changeRellinkOption(name, idField, opt = []) {
      if (idField && opt) {
        this.$emit('set-value', this.item, this.index, {
          [`${this.item.id}__${idField}`]: opt.map(o => o.name)
        });
      }
    },
    getField(fieldName) {
      return this.item.fields.find(({ name }) => name === fieldName) || {};
    }
  },
  components: {
    FormRow
  }
};
</script>
<style lang="scss" scoped>
.item {
  width: 100%;
  display: flex;
  flex-direction: column;

  &-row {
    display: flex;
    flex-direction: row;
    gap: 16px;
  }

  & ::v-deep label {
    margin: 0;
  }

  & ::v-deep .el-form-item__error {
    display: none;
  }

  .address-item {
    margin-right: 12px !important;
    width: calc(100% - 12px) !important;

    & ::v-deep .el-form-item__label {
      font-size: 14px !important;
      line-height: 24px !important;
    }

    & ::v-deep .el-form-item__content {
      line-height: 24px !important;
    }
  }
}
</style>
